export default {
  title_one: '🥳 {{offer}} anvendt',
  title_other: '🥳 {{count}} tilbud anvendt',
};
